// TwoPointCircleMarker.js
import { GalleryMarkerBase } from './GalleryMarkerBase.js';

export class TwoPointCircleMarker extends GalleryMarkerBase {
    draw(map) {
        const center = this.mapAdapter.createLatLng(this.points[0]);
        const edge = this.mapAdapter.createLatLng(this.points[1]);

        const radius = this.mapAdapter.getDistance(center, edge);

        const originMarker = this.createOriginMarker(center);
        this.drawnElements.push(originMarker);


        const circle = new google.maps.Circle({
            strokeColor: this.options.color,
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: this.options.color,
            fillOpacity: 0.2,
            map,
            center,
            radius,
            zIndex: this.options.zIndex
        });

        this.drawnElements.push(circle);
    }

    getBounds() {
        if(this.drawnElements[1] && typeof this.drawnElements[1].getBounds === 'function') {
            return this.drawnElements[1].getBounds();
        } else {
            // fallback zur Elternlogik
            return super.getBounds();
        }
    }
}